import { Accordion, AccordionSummary, Box, Button, CssBaseline, Typography } from "@material-ui/core";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import Grid from "@material-ui/core/Grid";
import Link from "@material-ui/core/Link";
import TextField from "@material-ui/core/TextField";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import FiberNewIcon from "@material-ui/icons/FiberNew";
import ListAltIcon from "@material-ui/icons/ListAlt";
import RefreshIcon from "@material-ui/icons/Refresh";
import Autocomplete from "@material-ui/lab/Autocomplete";
import ToggleButton from "@material-ui/lab/ToggleButton";
import ToggleButtonGroup from "@material-ui/lab/ToggleButtonGroup";
import { Form, Formik } from "formik";
import MaterialTable from "material-table";
import { DropzoneArea } from "material-ui-dropzone";
// @ts-ignore
import moment from "moment";
import LabelsContext from "../../../lang/LabelsContext";
import { getDesignationType, getTypeFromNameFile, handleFileType } from "../../../utils/Utils";
import EnumDesignation from "../../../utils/enum/EnumDesignation";
import { tableIcons } from "../../system/material-table-utils/MaterialTableUtils";
import ArticleCard from "../article-card/ArticleCard";
import ManageFilesService, { ManageFilesServiceType } from "./ManageFilesService";
import useStyles from "./ManageFilesStyle";

const SIZE_1MB = 1048576;

export default function ManageFiles() {
  const { Labels } = LabelsContext();
  const {
    article,
    openFileDialog,
    openFileDialogAction,
    closeFileDialogAction,
    designationOptions,
    uploadFile,
    handleResetDialog,
    files,
    uploading,
    filesByAssistant,
    deleteFile,
    revisionSelectedOptionAssistent,
    setRevisionSelectedOptionAssistent,
    updateAssitentFiles,
    selectedDesignation,
    openDialogRegenratePdf,
    downloadAllFigures,
  }: ManageFilesServiceType = ManageFilesService();
  const classes = useStyles();

  return (
    <>
      <CssBaseline />
      <Typography variant="h5">Manage files</Typography>
      <ArticleCard data={article} index={0} />

      {filesByAssistant &&
        Object.keys(filesByAssistant)
          .reverse()
          .map((id: any, index: number) => (
            <Accordion defaultExpanded={index === 0}>
              <AccordionSummary expandIcon={<ExpandMoreIcon />} aria-controls="panel1a-content" id="panel1a-header">
                <Typography className={classes.heading}>Revision #{id}</Typography>
              </AccordionSummary>
              <MaterialTable
                icons={tableIcons}
                columns={[
                  { title: Labels.FILE_NAME, field: "id", hidden: true },
                  {
                    title: Labels.FILE_NAME,
                    field: "name",
                    render: (rowData: any) => (
                      <Link href={rowData.location} color="inherit" component="a" target="_blank">
                        {rowData.name}
                        {rowData.type === EnumDesignation.OVERVIEW && <ListAltIcon color="action" />}
                      </Link>
                    ),
                  },
                  {
                    title: Labels.FILE_DESIGNATION,
                    field: "designation",
                    render: (rowData: any) => <div>{getDesignationType(rowData.designation, Labels)}</div>,
                  },
                  {
                    title: Labels.FILE_TYPE,
                    field: "type",
                  },
                  {
                    field: "uploadDate",
                    title: "Upload date",
                    defaultSort: "desc",
                    render: (rowData: any) => <div>{moment(rowData.uploadDate).format("YYYY-MM-DD HH:mm")}</div>,
                  },
                ]}
                data={updateAssitentFiles(filesByAssistant[id], revisionSelectedOptionAssistent) ?? []}
                options={{
                  actionsColumnIndex: -1,
                  pageSize: 10,
                  search: false,
                  actionsCellStyle: {
                    display: "flex",
                    justifyContent: "flex-end",
                    padding: 16,
                    width: "100%",
                  },
                }}
                editable={{
                  onRowDelete: (newData) => new Promise((resolve, reject) => resolve(deleteFile(newData.id))),
                }}
                actions={[
                  ({ new: newFile }) => ({
                    icon: () => <FiberNewIcon style={{ color: "green" }} />,
                    hidden: !newFile,
                    position: "row",
                    onClick: () => {},
                  }),
                  ({ id: fileId }) => ({
                    icon: () => <RefreshIcon />,
                    tooltip: `replace`,
                    hidden: Number(article?.revision) !== Number(id),
                    position: "row",
                    onClick: () => openFileDialogAction(fileId),
                  }),
                ]}
                title={
                  <Box display="flex" justifyContent="space-between" alignItems="center">
                    <Box display="flex" flexDirection="row" alignSelf="center">
                      <Typography>Files</Typography>
                    </Box>
                    <Box flex flexDirection="row" className={classes.box}>
                      <ToggleButtonGroup
                        value={revisionSelectedOptionAssistent}
                        onChange={(item, value: string) => setRevisionSelectedOptionAssistent(value)}
                        exclusive
                        aria-label="text alignment"
                      >
                        <ToggleButton value="all" aria-label="left aligned">
                          All
                        </ToggleButton>
                        <ToggleButton value="last" aria-label="centered">
                          Last
                        </ToggleButton>
                      </ToggleButtonGroup>
                      <Button
                        style={{
                          textTransform: "none",
                          fontSize: "18px",
                          marginInline: "10px",
                        }}
                        onClick={openFileDialogAction}
                        color="primary"
                        variant="contained"
                        size="small"
                      >
                        Add file
                      </Button>
                      <Button
                        style={{
                          textTransform: "none",
                          fontSize: "18px",
                          marginRight: "10px",
                        }}
                        onClick={downloadAllFigures}
                        color="primary"
                        variant="contained"
                        size="small"
                      >
                        Download figures
                      </Button>
                      <Button
                        style={{
                          textTransform: "none",
                          fontSize: "18px",
                        }}
                        onClick={openDialogRegenratePdf}
                        color="primary"
                        variant="contained"
                        size="small"
                      >
                        Regenerate full article pdf
                      </Button>
                    </Box>
                  </Box>
                }
              />
            </Accordion>
          ))}
      <Formik
        enableReinitialize
        initialValues={{
          designation: selectedDesignation
            ? designationOptions?.find((d: any) => d.code === selectedDesignation.designation)
            : designationOptions[0],
          size: "",
          type: "",
          comments: "",
        }}
        onSubmit={() => {}}
      >
        {({ handleBlur, values, touched, errors, handleChange, handleSubmit, setFieldValue }) => (
          <Form>
            <Dialog open={openFileDialog} onClose={closeFileDialogAction} aria-labelledby="form-dialog-title">
              <DialogTitle id="form-dialog-title">{Labels.FILE_UPLOAD}</DialogTitle>
              <DialogContent>
                <Grid container spacing={3}>
                  <Grid item xs={12}>
                    <Autocomplete
                      options={designationOptions}
                      getOptionLabel={(option: any) => option.name}
                      value={values.designation}
                      disabled={!!selectedDesignation}
                      onChange={(event, value) => setFieldValue("designation", value)}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          variant="outlined"
                          margin="normal"
                          id="designation"
                          name="designation"
                          onBlur={handleBlur}
                          label={Labels.FILE_DESIGNATION}
                          error={touched.designation && Boolean(errors.designation)}
                          helperText={touched.designation && errors.designation}
                          fullWidth
                        />
                      )}
                    />
                  </Grid>
                  <DropzoneArea
                    dropzoneProps={{ disabled: !values.designation }}
                    acceptedFiles={handleFileType(values.designation?.code)}
                    maxFileSize={SIZE_1MB * 50} //50MB
                    onChange={(files: File[]) => {
                      if (files.length > 0) {
                        handleResetDialog(
                          true,
                          setFieldValue,
                          files,
                          (files[0].size / SIZE_1MB).toFixed(2) + " mb",
                          getTypeFromNameFile(files[0].name)
                        );
                      }
                    }}
                    onDelete={(file: File) => {
                      handleResetDialog(false, setFieldValue, null, "", "");
                    }}
                    filesLimit={1}
                  />
                  <Grid item xs={12} sm={6}>
                    <TextField
                      disabled={true}
                      variant="outlined"
                      margin="normal"
                      id="size"
                      name="size"
                      onBlur={handleBlur}
                      label={Labels.SIZE}
                      value={values.size}
                      error={touched.size && Boolean(errors.size)}
                      helperText={touched.size && errors.size}
                      fullWidth
                    />
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <TextField
                      disabled={true}
                      variant="outlined"
                      margin="normal"
                      id="type"
                      name="type"
                      label={`${Labels.FILE_TYPE}:`}
                      value={values.type}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      error={touched.type && Boolean(errors.type)}
                      helperText={touched.type && errors.type}
                      fullWidth
                      required
                    />
                  </Grid>
                  <Grid item xs={12}>
                    <TextField
                      variant="outlined"
                      margin="normal"
                      id="comments"
                      name="comments"
                      onBlur={handleBlur}
                      label={Labels.COMMENTS}
                      error={touched.comments && Boolean(errors.comments)}
                      helperText={touched.comments && errors.comments}
                      fullWidth
                      multiline
                      rows={5}
                    />
                  </Grid>
                </Grid>
              </DialogContent>
              <DialogActions>
                <Button
                  onClick={() => {
                    closeFileDialogAction();
                    handleResetDialog(false, setFieldValue, [], "", "");
                  }}
                  color="primary"
                >
                  {Labels.CANCEL}
                </Button>
                <Button
                  disabled={uploading}
                  onClick={() => {
                    uploadFile(files, values);
                    handleResetDialog(false, setFieldValue, null, "", "");
                  }}
                  color="primary"
                  variant={"contained"}
                >
                  {Labels.UPLOAD}
                </Button>
              </DialogActions>
            </Dialog>
          </Form>
        )}
      </Formik>
    </>
  );
}
